import { render, staticRenderFns } from "./CryptoDepositModal.vue?vue&type=template&id=55b740b8&scoped=true&"
import script from "./CryptoDepositModal.vue?vue&type=script&lang=js&"
export * from "./CryptoDepositModal.vue?vue&type=script&lang=js&"
import style0 from "./CryptoDepositModal.vue?vue&type=style&index=0&id=55b740b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b740b8",
  null
  
)

export default component.exports